import React from 'react';
import { IonLabel } from '@ionic/react';
import styles from './Logo.module.css';

export const Logo = () => {
  return (
    <IonLabel color="medium" className={styles.logo}>
      <img
        className={styles.logoIcon}
        src="assets/icon/logo_transparent.svg"
        alt="Helpo logo"
      />
      HELPO
    </IonLabel>
  );
};
